import ApplicationController from 'javascript/controllers/application_controller';
import { clearAllTicketOrderStorage } from 'javascript/utils/ticket_cart_storage';

export default class extends ApplicationController {
  connect() {
    this.clearOrderSessionStorageOnLoad();
    window.addEventListener(
      'turbo:before-visit',
      this.clearOrderSessionStorage,
    );
  }

  disconnect() {
    window.removeEventListener(
      'turbo:before-visit',
      this.clearOrderSessionStorage,
    );
  }

  clearOrderSessionStorageOnLoad() {
    if (!this.getCookieValue('clear_ticket_order_session_storage')) return;

    clearAllTicketOrderStorage();
    this.removeCookie('clear_ticket_order_session_storage');
  }

  clearOrderSessionStorage = (event) => {
    const shouldClearTicketOrderSessionStorage = this.getCookieValue(
      'clear_ticket_order_session_storage',
    );

    if (!shouldClearTicketOrderSessionStorage) return;

    const nextUrl = event?.detail?.url;
    if (
      this.isEventTicketSelectionUrl(window.location.href) &&
      nextUrl &&
      this.isEventTicketSelectionUrl(nextUrl)
    ) {
      // Category tab frame navigations change the URL but keep the same checkout step.
      this.removeCookie('clear_ticket_order_session_storage');
      return;
    }

    clearAllTicketOrderStorage();
    this.removeCookie('clear_ticket_order_session_storage');
  };

  isEventTicketSelectionUrl(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      return /^\/events\/[^/]+\/tickets$/.test(path);
    } catch {
      return false;
    }
  }

  getCookieValue = (cname) => {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  removeCookie = (name) => {
    document.cookie =
      name + '=; Max-Age=0; path=/; domain=' + window.location.hostname;
  };
}
